export const environment = {
    production: true,
    authUrl: 'https://be-qa.audacity.lcgtech.pt/',
    apiUrl: 'https://be-bo-qa.audacity.lcgtech.pt/',
};
